import actions from './actions';
import mutations from './mutations';
import state from './schema';

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
